import { FORUM_MESSAGE_LENGTH } from '../constants';

import displayEmoticons from '../features/display-emoticons';
import attachCharacterCounterEvents from '../forms/character-counter';
import { validateForumPostForm } from '../forms/forumpost';

export default function attachForumEvents() {
    validateForumPostForm('#forum-post-message-form');
    attachCharacterCounterEvents(FORUM_MESSAGE_LENGTH);
    displayEmoticons('.has-review-emoticons');
}
